import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InputValuePipe } from '../../shared/pipes/input-value/input-value.pipe';

@Component({
  selector: 'app-material-textarea-demo',
  templateUrl: './material-textarea-demo.component.html',
  styleUrls: ['./material-textarea-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialTextareaDemoComponent {
  placeholder = `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. `;
  note1 = '';
  note2 = this.placeholder;
  note3 = '';
  note4 = this.placeholder;
  note5 = '';
  note6 = this.placeholder;
  note7 = this.placeholder;
  note8 = '';
  note9 = this.placeholder;
  note10 = '';
  note11 = this.placeholder;
  note12 = '';
  note13 = this.placeholder;
  note14 = this.placeholder;

  constructor(private inputValuePipe: InputValuePipe) {}

  getValue(event: Event): string {
    return this.inputValuePipe.transform(event);
  }
}
